module.exports = __webpack_public_path__ + "img/50.35660b65.png";